document.addEventListener('DOMContentLoaded', function () {
  const $navItems = $('.product_section_switch .nav_tabs .nav_item');
  const $bar = $('.product_section_switch__bar');
  const $switch = $bar.closest('.product_section_switch');

  if (!$navItems.length || !$bar.length) return;

  let lastScrollTop = 0;
  let barOriginTop = 0;
  let ticking = false;
  let clickLockUntil = 0;
  let originRaf = 0;

  function getScrollOffset() {
    // is-hidden uses transform only — outerHeight() still reports full height.
    // When the bar is off-screen, spy/jump against the viewport top instead.
    if ($bar.hasClass('is-hidden')) {
      return 8;
    }
    return $bar.outerHeight() + 8;
  }

  function ensureTabVisible($tab) {
    const el = $tab && $tab[0];
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  function resolveTarget($item) {
    const goid = $item.data('goid');
    if (goid === '' || goid == null) {
      return $item.closest('.shopify-section').next();
    }
    const $target = $(goid);
    return $target.length ? $target : null;
  }

  function setActive($item, scrollTab) {
    if (!$item || !$item.length) return;
    if ($item.hasClass('active')) {
      return;
    }
    $navItems.removeClass('active');
    $item.addClass('active');
    if (scrollTab) ensureTabVisible($item);
  }

  function updateBarOrigin() {
    // Measure natural document position (ignore fixed/hidden transform)
    const wasFixed = $bar.hasClass('is-fixed');
    const wasHidden = $bar.hasClass('is-hidden');
    if (wasFixed) {
      $bar.removeClass('is-fixed');
      $switch.css('height', '');
    }
    if (wasHidden) $bar.removeClass('is-hidden');
    barOriginTop = $switch.offset().top;
    if (wasFixed) {
      $bar.addClass('is-fixed');
      $switch.css('height', $bar.outerHeight());
    }
    if (wasHidden) $bar.addClass('is-hidden');
  }

  function scheduleBarOriginUpdate() {
    if (originRaf) return;
    originRaf = requestAnimationFrame(function () {
      originRaf = 0;
      updateBarOrigin();
      handleStickyBar($(window).scrollTop());
    });
  }

  function handleStickyBar(scrollTop) {
    // Remeasure while not fixed so late-loading widgets (e.g. CBB) don't leave a stale origin.
    if (!$bar.hasClass('is-fixed')) {
      barOriginTop = $switch.offset().top;
    }

    if (scrollTop <= barOriginTop) {
      $bar.removeClass('is-fixed');
      $bar.removeClass('is-hidden');
      $switch.css('height', '');
      lastScrollTop = scrollTop;
      return;
    }

    if (!$bar.hasClass('is-fixed')) {
      $bar.addClass('is-fixed');
      $switch.css('height', $bar.outerHeight());
    }

    if (scrollTop > lastScrollTop + 2) {
      // scrolling down → show
      $bar.removeClass('is-hidden');
    } else if (scrollTop < lastScrollTop - 2) {
      // scrolling up → hide (avoid header overlap)
      $bar.addClass('is-hidden');
    }

    lastScrollTop = scrollTop;
  }

  function handleScrollSpy() {
    if (Date.now() < clickLockUntil) return;

    const offset = getScrollOffset();
    let activeIndex = 0;
    let bestRectTop = -Infinity;

    // Viewport-based spy: pick the target whose top is closest to the nav bar (but not below it).
    $navItems.each(function (index) {
      const $target = resolveTarget($(this));
      if (!$target || !$target.length) return;

      const el = $target[0];
      const rectTop = el.getBoundingClientRect().top;
      if (rectTop <= offset + 2 && rectTop > bestRectTop) {
        bestRectTop = rectTop;
        activeIndex = index;
      }
    });

    const $active = $navItems.eq(activeIndex);
    const scrollTab = !$active.hasClass('active');
    setActive($active, scrollTab);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      const scrollTop = $(window).scrollTop();
      handleStickyBar(scrollTop);
      handleScrollSpy();
      ticking = false;
    });
  }

  // Click: jump + activate + scroll tab into view
  $navItems.on('click', function () {
    const $item = $(this);
    $navItems.removeClass('active');
    $item.addClass('active');
    // Lock before any scroll animation so scrollspy can't fight tab/content jumps.
    clickLockUntil = Date.now() + 1200;
    ensureTabVisible($item);

    const $target = resolveTarget($item);
    if (!$target || !$target.length) return;

    // Ensure bar is visible when jumping so offset is correct
    $bar.removeClass('is-hidden');

    const offset = getScrollOffset();
    $('html, body').stop(true).animate(
      { scrollTop: Math.max(0, $target.offset().top - offset) },
      300,
      function () {
        // Never shorten the click lock; only extend if animation finished later than expected.
        clickLockUntil = Math.max(clickLockUntil, Date.now() + 200);
      }
    );
  });

  // External review-line trigger
  $('#review-line').on('click', function () {
    const $review = $navItems.filter("[data-goid='#az_reviews']");
    if ($review.length) {
      $review.trigger('click');
    } else if ($('#az_reviews').length) {
      $('html, body').animate(
        { scrollTop: Math.max(0, $('#az_reviews').offset().top - getScrollOffset()) },
        300
      );
    }
  });

  updateBarOrigin();
  lastScrollTop = $(window).scrollTop();
  $(window).on('scroll', onScroll);
  $(window).on('resize orientationchange', function () {
    updateBarOrigin();
  });

  // Late-loading plugins (CBB FBT, etc.) change page height above this section.
  const observeRoot =
    document.getElementById('MainContent') ||
    document.querySelector('main') ||
    document.body;

  if (typeof ResizeObserver !== 'undefined') {
    const resizeObserver = new ResizeObserver(function () {
      scheduleBarOriginUpdate();
    });
    resizeObserver.observe(observeRoot);
  }

  if (typeof MutationObserver !== 'undefined') {
    const mutationObserver = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        const nodes = mutations[i].addedNodes;
        for (let j = 0; j < nodes.length; j++) {
          const node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (
            node.classList.contains('cbb-frequently-bought-container') ||
            node.querySelector('.cbb-frequently-bought-container')
          ) {
            scheduleBarOriginUpdate();
            return;
          }
        }
      }
    });
    mutationObserver.observe(observeRoot, { childList: true, subtree: true });
  }
});
